import 'babel-polyfill'
import 'regenerator-runtime/runtime'
import Vue from 'vue'
import axios from 'axios'
import App from './App'
import Button from './components/Button'
import Modal from '../../components/modal'
import Tooltip from '../../components/toolTip'
import { cookie } from '../../utils/cookie'
import { initSentry } from '../../utils/Sentry'

import './style/index.scss'

initSentry()
Vue.use(Button)
Vue.use(Tooltip)
Vue.use(Modal)
Vue.prototype.PageInfo = PageInfo
Vue.prototype.getConstants = props => Constants[props] || props
Vue.prototype.$ajax = axios
Vue.prototype.switchLang = lang => {
	const current = cookie.get('page_locale')
	if (current !== lang) {
		cookie.set('page_locale', lang)
		location.reload()
	}
}

void new Vue({
	el: '#app',
	render: h => h(App),
})
